'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); //import Vas from '../Vas';


var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * class to send ajax requests
 */
var RequestHelper = function () {
    function RequestHelper() {
        _classCallCheck(this, RequestHelper);
    }

    _createClass(RequestHelper, null, [{
        key: 'SendAuthorised',

        /**
           * sends an authorised ajax request
           * @param url specific url for request
           * @param async true if async
           * @param reqType post or get
           * @param sendData data json object to send
           * @param jsonData true if it data type of data is json
           * @constructor
           */
        value: function SendAuthorised(url, async, reqType, sendData, jsonData) {}
        /*let dataContent = sendData;
              if(jsonData)
                dataContent = JSON.stringify(sendData);
              return $.ajax({
                dataType: 'json',
                contentType: 'application/json',
                async: async,
                url: url,
                type: reqType,
                data: dataContent,
                beforeSend: function (xhr) 
                {
                    xhr.setRequestHeader('accept-language', localStorage.getItem('vas_language'));
                    xhr.setRequestHeader('x-sts-APIKey', Vas.ApiKey);
                    xhr.setRequestHeader('authorization', localStorage.getItem('vas_token'));
                }
            })*/

        /**
           * sends an anonymous ajax request
           * @param url specific url for request
           * @param async true if async
           * @param reqType post or get
           * @param sendData data json object to send
           * @constructor
           */

    }, {
        key: 'SendAnonymous',
        value: function SendAnonymous(url, async, reqType, sendData) {
            /*return $.ajax({
                    dataType: 'json',
                    contentType: 'application/json',
                    async: async,
                    url:   url,
                    type:  reqType,
                    data:  sendData,
                    beforeSend: function (xhr)
                    {
                        xhr.setRequestHeader('accept-language', localStorage.getItem('vas_language'));
                        xhr.setRequestHeader('x-sts-APIKey', Vas.ApiKey);
                    }
                });*/
        }
    }]);

    return RequestHelper;
}();

exports.default = RequestHelper;